import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { questions } from '../data/faq';
export function FAQ() {
  const [open, setOpen] = useState(0);
  return <section className="border-t border-white/5 bg-carbon py-20" aria-labelledby="faq-title" data-id="element-76" data-mp="1cf05zhpnxgq5">
      <div className="mx-auto max-w-3xl px-4" data-id="element-77" data-mp="2a1ytb1ugtcbd">
        <SectionHeading id="faq-title" data-id="element-78" data-mp="2a1qidfhwkh2t">Frequently Asked Questions</SectionHeading>
        <div className="mt-10 space-y-3" data-id="element-79" data-mp="2547084i33k5l">
          {questions.map(([question, answer], index) => {
          const isOpen = index === open;
          return <article key={question} className={`overflow-hidden rounded-xl border bg-petrol transition-colors duration-150 ease-out ${isOpen ? 'border-lava' : 'border-lava/20'}`} data-id="element-80" data-mp="1v580jbfaqyuq" data-mpi={index}>
                <h3 className="font-sans" data-id="element-81" data-mp="jp1bh6sp8re3">
                  <button type="button" className="flex w-full items-center justify-between gap-5 px-5 py-5 text-left font-bold text-snow transition-colors duration-150 ease-out hover:bg-petrol-light focus:outline-none focus-visible:ring-4 focus-visible:ring-inset focus-visible:ring-energy/50 sm:px-6" onClick={() => setOpen(isOpen ? -1 : index)} aria-expanded={isOpen} data-id="element-82" data-mp="js5liksuihco">
                    <span data-id="element-83" data-mp="11vnv1mpwt1io">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-lava transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-84" data-mp="16np6x7j60q86" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-85" data-mp="wvt63opp2m09">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-86" data-mp="j0hdpnz0h7mi">
                      <p className="border-t border-white/10 px-5 py-4 leading-relaxed text-muted sm:px-6" data-id="element-87" data-mp="2ku3pov68mst8">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </article>;
        })}
        </div>
      </div>
    </section>;
}